const breadcrumb = {
    checkForResize: () => {
        const updateBreadcrumb = () => {
            const breadcrumbContainer = document.getElementById("breadcrumbContainer");
            if (!breadcrumbContainer) return;
            const isMobile = window.innerWidth < 768;
            breadcrumbContainer.style.display = isMobile ? "none" : "flex";
        }
        
        // Update breadcrumb on window resize
        window.addEventListener("resize", updateBreadcrumb);
    }
};

// Load breadcrumbs
document.addEventListener('DOMContentLoaded', () => {
    breadcrumb.checkForResize();
});
